import { FC } from "react"
import React,{useEffect, useState, useMemo } from "react";
import { useIntl } from "react-intl"
import { PageTitle } from "../../../smallnation/layout/core"
import services from "../../modules/services/services"
//import { useSearchParams } from 'react-router-dom'
import moment from "moment"
import { KTSVG } from "../../../smallnation/helpers"
//import { useNavigate,useParams,useLocation,useHistory } from "react-router-dom";
import {  useLocation, useHistory } from "react-router-dom";
//import {  BrowserRouter as Router, Link,  useLocation} from "react-router-dom";
import { ErrorMessage } from "@hookform/error-message";
import { set, useForm } from "react-hook-form";
import $ from 'jquery';

//import { TablesWidget10, TablesWidget5,TablesWidget1, TablesWidget2,TablesWidget3,TablesWidget4,TablesWidget6,TablesWidget7,TablesWidget8,TablesWidget9,TablesWidget11,TablesWidget12,TablesWidget13  } from "../../../smallnation/partials/widgets"
//import { ProfileDirectoryInc } from "../../../smallnation/partials/widgets/tables/profileDirectoryInc"


const CreateIndustry: FC = () => {
      const intl = useIntl();
      const red="red";
      let history = useHistory();
      const {
        register,
        formState: { errors },
        handleSubmit
      } = useForm({
        criteriaMode: "all",mode: "onBlur" 
      });

      const submitValue = () => {
        var validateEditorTxt = 1;
        if($('#category_name').val() == ""){
          $("#categoryNameValidMsg").show();  
          $(window).scrollTop($('#categoryNameValidMsg').position().top);
          validateEditorTxt = 0;     
        }else{
          $("#categoryNameValidMsg").hide();  
        }

        if(validateEditorTxt == 0){
          return false;
         }
  

        const requestObject={
          "name":$("#category_name").val(),
        }
        console.log(requestObject);
        var accessTokenIn=sessionStorage.getItem("adminAccToken");
        const requestOptions = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json',
                    //'Authorization': "Bearer "+accessTokenIn 
                    //'Authorization': accessTokenIn 
                  },
          body: JSON.stringify(requestObject)
        };

        services.adminAddIndustryCategory(requestOptions).then((res) => 
        {

          if (res.code == '200') {  
            $("#addindutrysuccessMessage").fadeTo(2000, 500).slideUp(500, function () {
              $("#addindutrysuccessMessage").slideUp(500);
            });
            setTimeout(() => {
              history.push('/industrylist');
            }, 1000);
          }
          else{
            $("#addindutryfailMessage").fadeTo(2000, 500).slideUp(500, function () {
              $("#addindutryfailMessage").slideUp(500);
            });
            setTimeout(() => {
              
            }, 1000);
          }
        });
        
      }
     
      useEffect(() => 
      {       
       $('#categoryNameValidMsg').hide();
       $('#addindutrysuccessMessage').hide();
       $('#addindutryfailMessage').hide();
      },[]);
      type Props = {
        className: string
      }
      return (
        <>
          <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'Create Industry Category'})}</PageTitle>
          <form   onSubmit={handleSubmit(submitValue)}>     
             <div className="container">
               <div className="row">
                 

                 <div className="col-lg-12">
                 <div className="mb-4">
                 <div className="d-flex flex-column ">
                 <label htmlFor="exampleFormControlInput1" className="required form-label">Industry Category Title</label>
                 
                 </div>
                  <input type="text" id="category_name" name="category_name" className="form-control" placeholder=""  />
                                <div id="categoryNameValidMsg" style={{color:red}} className="error">Industry Category Title is required.</div>
              </div>
                 </div>
                
                
                 <div className="col-lg-12">
                 <div className="mb-5 px-3">
                 <div className="d-flex flex-column ">
                 <div className="row mt-2">
                    <div className="divider"></div>
                    <button type="submit" className="btn btn-primary mt-10" style={{maxWidth:"200px"}}> Create Industry </button>
                 </div>
                 </div>
                 <div id="addindutrysuccessMessage" className="alert alert-success" role="alert">Industry Added Successfully</div>
                 <div id="addindutryfailMessage" className="alert alert-danger" role="alert">Please try again</div>
              </div>
                 </div>

               </div>
             </div>
             </form>
        </>
      )
    }
export {CreateIndustry}